import React, { FC } from 'react';
import { ReactComponent as MemoryIcon } from '../../icons/nav-links/memory.svg';
import './memory-empty-state.scss';

interface MemoryEmptyStateProps {
  variant: 'unconfirmed' | 'aboutYou' | 'organisation' | 'relationships';
}

const MemoryEmptyState: FC<MemoryEmptyStateProps> = ({ variant }) => {
  const getContent = () => {
    switch (variant) {
      case 'unconfirmed':
        return {
          title: 'No memories waiting for confirmation',
          description:
            "Your Dreamies use memories to work faster and better. They'll add new memories here as they find them, or when you tell them something.",
        };
      case 'aboutYou':
        return {
          title: "There aren't any memories here yet",
          description:
            "Your Dreamies use memories to work faster and better. They'll add new memories here as they find them, or when you tell them something.",
        };
      case 'organisation':
        return {
          title: "There aren't any memories here yet",
          description:
            "Your Dreamies use memories to work faster and better. They'll add new memories here as they find them, or when you tell them something.",
        };
      case 'relationships':
        return {
          title: "There aren't any memories here yet",
          description:
            "Your Dreamies use memories to work faster and better. They'll add new memories here as they find them, or when you tell them something.",
        };
    }
  };

  const content = getContent();

  return (
    <div className='memory-empty-state'>
      <div className='icon'>
        <MemoryIcon />
      </div>
      <h3 className='title'>{content.title}</h3>
      <p className='description'>{content.description}</p>
    </div>
  );
};

export default MemoryEmptyState;
